module.exports = __webpack_public_path__ + "static/media/cities.3c2ddcb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/home-discover/images/cities.png
// module id = 653
// module chunks = 0